// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__OByax","defaultTextColor":"Breadcrumbs_defaultTextColor__CrQl5"};